// extracted by mini-css-extract-plugin
module.exports = {"basketBtnWrapper":"styles_basketBtnWrapper__7ghY3","heading":"styles_heading__XdYQZ","workarea":"styles_workarea__wTdRS","title":"styles_title__BSmP2"};